"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Codes of keys used in HTML dom events.
 */
exports.KEYCODES = {
    ESC: 27,
    ENTER: 13,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    SHIFT: 16,
    TAB: 9,
    SPACE: 32,
    END: 35,
    HOME: 36,
    PAGE_UP: 33,
    PAGE_DOWN: 34
};
